<main>
    <div class="content">
        <div class="image-container">
            <img [src]="baseApiUrl + '/uploads/images/publications/published_report/published_report_1.jpg'" alt="" class="main-image">
            <p class="image-text">{{ 'report.Key Operational Performance' | translate }}</p>
        </div>
        <nav class="navbar navbar-expand-lg navbar-light bg-light">
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarNav">
                <ul class="navbar-nav">
                    <li class="nav-item">
                        <a class="nav-link" href="/publication/published-report">{{ 'report.Annual Report' | translate }}</a>
                    </li>      
                    <li class="nav-item">
                        <a class="nav-link" href="/publication/key-financial">{{ 'report.Key Financial Performance' | translate }}</a>
                    </li>     
                    <li class="nav-item active">
                        <a class="nav-link" href="/publication/key-operational">{{ 'report.Key Operational Performance' | translate }}</a>
                    </li>     
                    <li class="nav-item">
                        <a class="nav-link" href="/publication/csr">{{ 'report.CSR' | translate }}</a>
                    </li>             
                </ul>
            </div>
        </nav>
        <div class="key-operational">
           <h3>{{ 'report.Key Operational Performance' | translate }}</h3>
           <!-- <img src="images/publications/key_operation/key_operational_2.png" alt="">
           <img src="images/publications/key_operation/key_operational_3.png" alt=""> -->
           <table class="table table-hover" style="background-color: white; margin-top: 50px;">
            <thead style="background-color: #005EB8; color: white;">
              <tr>
                <th scope="col">Performance Indicator</th>
                <th scope="col">2024</th>
                <th scope="col">2023</th>
                <th scope="col">2022</th>
                <th scope="col">2021</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>City/provinces</td>
                <td>15</td>
                <td>15</td>
                <td>15</td>
                <td>13</td>
              </tr>
              <tr>
                <td>Districts</td>
                <td>89</td>
                <td>93</td>
                <td>90</td>
                <td>77</td>
              </tr>
              <tr>
                <td>Communes</td>
                <td>538</td>
                <td>541</td>
                <td>512</td>
                <td>459</td>
              </tr>
              <tr>
                <td>Villages</td>
                <td>2,255</td>
                <td>2,371</td>
                <td>2,348</td>
                <td>1,945</td>
              </tr>
              <tr>
                <td>Branch offices</td>
                <td>25</td>
                <td>25</td>
                <td>27</td>
                <td>25</td>
              </tr>
              <tr>
                <td>Active accounts</td>
                <td>11,076</td>
                <td>14,369</td>
                <td>17,682</td>
                <td>17,373</td>
              </tr>
              <tr>
                <td>Gross loan outstanding (USD)</td>
                <td>56,431,064</td>
                <td>63,831,245</td>
                <td>73,930,980</td>
                <td>55,770,414</td>
              </tr>
              <tr>
                <td>PAR ratio (30 days)</td>
                <td>11.37%</td>
                <td>10.42%</td>
                <td>1.88%</td>
                <td>1.50%</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="bottom-content-poster">
            <img [src]="baseApiUrl + '/uploads/images/customer_service/customer_service_1.jpg'" alt="">
            <a href="/download-app"><img [src]="baseApiUrl + '/uploads/images/mobile_download/mobile_download_1.jpg'" loading="lazy"></a>
        </div>
    </div>
</main>
